import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "aria-labelledby"]
const _hoisted_2 = { class: "o-brokerPreview__top" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "o-brokerPreview__bottom" }
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "o-brokerPreview__logo",
  src: "/assets/images/logo.svg",
  alt: "danbolig logo",
  width: "152",
  height: "35",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "o-brokerPreview__addressElement" }
const _hoisted_9 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_10 = {
  key: 1,
  style: {"display":"inline-block"}
}
const _hoisted_11 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: `/ejendomsmaegler/${$props.broker.url}/`,
    class: "o-brokerPreview",
    "aria-labelledby": $data.uuid,
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveBroker($props.broker.brokerId))),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveBroker(null))),
    onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.onClick()))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $options.formattedUrl,
        class: "o-brokerPreview__image",
        loading: "lazy",
        onerror: "this.onerror=null;this.src='/assets/images/fallback/brokerFallbackImage.svg'"
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", {
        id: $data.uuid,
        class: _normalizeClass(["o-brokerPreview__address", { isMultiline: $data.isMultiline }])
      }, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "a-lead o-brokerPreview__name",
          textContent: _toDisplayString($props.broker.name.replace('danbolig ', ''))
        }, null, 8 /* PROPS */, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          ($props.broker.address)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($props.broker.address) + _toDisplayString($data.isMultiline ? ',' : '') + "  ", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($props.broker.zipCode || $props.broker.city)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($props.broker.zipCode ? $props.broker.zipCode : '') + " " + _toDisplayString($props.broker.city ? $props.broker.city : ''), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        ($props.broker.phone)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "o-brokerPreview__phone",
              textContent: _toDisplayString($props.broker.phone)
            }, null, 8 /* PROPS */, _hoisted_11))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_5)
    ])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}